import { Alert } from "@material-ui/lab";
import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { masterCardLogoImage } from "../../../../assets";

function ConfirmMove(props) {
  const { requestData, confirmMove, errMessage } = props;
  const { id, final_amount, discount, request_type, payment_method } =
    requestData.request;
  const { name } = requestData.bid_Accepted_company;

  return (
    <>
      <div className="row">
        <div className="col-0 col-sm-2 col-md-2 col-xl-3"></div>
        <div className="col-12 col-sm-8 col-md-8 col-xl-5">
          {errMessage && (
            <Alert variant="filled" severity="error">
              {errMessage}
            </Alert>
          )}
          <div className="form-box-wrapper">
            <>
              <span className="mt-4 black-bold-15" id="change-filter-title">
                Are you sure you want to confirm move and release money against
                request #{id} ?
              </span>

              <div className="form-box ">
                <div className="row">
                  <div className="col-12 change-card-option mt-3 mb-3 pointer-point"></div>

                  <div className="row ml-2">
                    <div className="col-6 ">
                      <span className="small-font-size dark-grey-color overline">
                        Company Name:
                      </span>
                    </div>
                    <div className="col-6 ">
                      <span className="font-weight-bold pl-3">{name}</span>
                    </div>
                    {request_type && (
                      <>
                        <div className="col-6 ">
                          <span className="small-font-size dark-grey-color overline">
                            Payment Method
                          </span>
                        </div>
                        <div className="col-6">
                          <span className="font-weight-bold pl-3">
                            {payment_method}
                          </span>
                        </div>
                      </>
                    )}
                    <div className="col-6 ">
                      <span className="small-font-size dark-grey-color overline">
                        Final price:
                      </span>
                    </div>
                    <div className="col-6">
                      <span className="font-weight-bold pl-3">
                        ${final_amount}
                      </span>
                    </div>
                    {parseInt(discount) > 0 && (
                      <>
                        {/* discount */}
                        <div className="col-6 ">
                          <span className="small-font-size dark-grey-color overline">
                            Discount:
                          </span>
                        </div>
                        <div className="col-6">
                          <span className="font-weight-bold pl-3">
                            {discount}%
                          </span>
                        </div>
                        {/* Discounted amount */}
                        <div className="col-6 ">
                          <span className="small-font-size dark-grey-color overline">
                            Discounted Price:
                          </span>
                        </div>
                        <div className="col-6">
                          <span className="font-weight-bold pl-3">
                            ${final_amount * (1 - parseInt(discount) / 100)}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="col-12 pt-2 pb-3 pt-4">
                    <button
                      type="button"
                      onClick={() => {
                        //call function is use checked agree
                        confirmMove(id);
                      }}
                      className="red-btn custom-buton custom-buton-large w-100"
                    >
                      {request_type
                        ? "Confirm your move"
                        : "Confirm move and release money"}
                    </button>
                  </div>

                  {/* <div className="col-12">123</div> */}
                </div>
              </div>
            </>
          </div>
        </div>
        <div className="col-0 col-sm-2 col-md-2 col-xl-4"></div>
      </div>
    </>
  );
}

export default ConfirmMove;
